export const ACCOUNT_NAMESPACE = "account";
